module.exports = __webpack_public_path__ + "img/4-4.58685ba0.svg";